export default __webpack_public_path__ + "static/media/hht1_ep4_minisitcom_01.eaf6f5dd.png";